// src/services/sanklan.js
import { api, extractJsonObject } from "./api";

function toJson(respData) {
  if (respData && typeof respData === "object") return respData;
  const cleaned = extractJsonObject(String(respData ?? ""));
  return JSON.parse(cleaned);
}

export async function fetchSanklanRows({
  mainuser,
  kendramobno,
  date,
  shift,
  milk,
}) {
  const resp = await api.get("get_sanklan_list.php", {
    params: { mainuser, kendramobno, date, shift, milk, _ts: Date.now() },
  });

  const j = toJson(resp.data);
  if (!j.ok) throw new Error(j.error || "Failed to load collections");
  return Array.isArray(j.rows) ? j.rows : [];
}

// ✅ Save Sanklan (existing)
export async function saveSanklan(payload) {
  const body = new URLSearchParams();
  Object.entries(payload || {}).forEach(([k, v]) => body.append(k, v ?? ""));

  const resp = await api.post("savesanklanmd2.php", body.toString(), {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });

  return typeof resp.data === "string" ? resp.data : JSON.stringify(resp.data);
}

// ✅ NEW: bill date ranges (same as Android getbilldatesmd3.php)
export async function fetchBillDateRanges({ mainuser, paymentperiodsettings }) {
  const cacheKey = `billdates_cache::${mainuser}||${paymentperiodsettings}`;
  const etag = localStorage.getItem(cacheKey + "::etag") || "";

  // try cache body first (fast UI)
  const cachedBody = localStorage.getItem(cacheKey + "::body") || "";
  let cached = null;
  try {
    if (cachedBody) cached = JSON.parse(cachedBody);
  } catch (e) {}

  const resp = await api.get("getbilldatesmd3.php", {
    params: { mainuser, paymentperiodsettings },
    headers: etag ? { "If-None-Match": etag } : undefined,
    validateStatus: (s) => (s >= 200 && s < 300) || s === 304,
  });

  if (resp.status === 304) {
    return {
      rows: Array.isArray(cached) ? cached : [],
      allowExtend:
        String(resp.headers?.["x-allow-extend"] || "").toLowerCase() === "true" ||
        String(resp.headers?.["x-allow-extend"] || "") === "1",
      fromCache: true,
    };
  }

  const allowExtend =
    String(resp.headers?.["x-allow-extend"] || "").toLowerCase() === "true" ||
    String(resp.headers?.["x-allow-extend"] || "") === "1";

  const newETag = resp.headers?.etag || "";
  const body = resp.data;

  // server returns JSON array
  let arr = [];
  try {
    arr = typeof body === "string" ? JSON.parse(body) : body;
  } catch (e) {
    arr = [];
  }

  localStorage.setItem(cacheKey + "::etag", newETag || "");
  localStorage.setItem(cacheKey + "::body", JSON.stringify(arr || []));

  return { rows: Array.isArray(arr) ? arr : [], allowExtend, fromCache: false };
}

// ✅ NEW: get sanklan by KNO range (same as Android get_sanklan_by_kno_range.php)
export async function fetchSanklanByKnoRange({ mainuser, kno, fromIso, toIso }) {
  const resp = await api.get("get_sanklan_by_kno_range.php", {
    params: { mainuser, kno, from: fromIso, to: toIso, t: Date.now() },
  });

  // server returns JSON array
  let arr = [];
  try {
    arr = typeof resp.data === "string" ? JSON.parse(resp.data) : resp.data;
  } catch (e) {
    arr = [];
  }
  return Array.isArray(arr) ? arr : [];
}

// ✅ FIXED: Apply rates (must use api baseURL, not fetch relative to localhost:3000)
export async function applySanklanRates({ mainuser, itemsJson }) {
  const body = new URLSearchParams();
  body.append("mainuser", String(mainuser || ""));
  body.append("items", String(itemsJson || "[]"));

  const resp = await api.post("update_sanklan_rates_apply.php", body.toString(), {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });

  const j = toJson(resp.data);
  if (!j?.ok) throw new Error(j?.error || "Server error");
  return j; // { ok:true, updated, skipped }
}
